export enum LocationValues {
  IleDeFrance = 'ile-de-france',
  OtherRegions = 'other-regions',
}
